var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OrganismNav',{staticClass:"hidden md:block",attrs:{"left-menu":_vm.desktopLeftMenu,"right-menu":_vm.desktopRightMenu}}),_vm._v(" "),_c('OrganismNavMobile',{staticClass:"md:hidden",attrs:{"menu":_vm.mobileMenu,"mobile-head-link":_vm.mobileHeadLink}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }